<template>
  <!-- 6-3 教育机构查看岗位详情 -->
  <div class="main-css">
    <!-- 头部 信息显示 -->
    <div class="top-title">
      <div class="top-name">
        {{ $t("medicalInstitution") }} {{ this.tableData.medicalName }}
      </div>
      <div class="case-num">
        {{ $t("recruiter") }} {{ this.tableData.userName }}
      </div>
      <div class="case-num">
        {{ $t("caseNumber") }}{{ this.tableData.jobId }}
      </div>
    </div>
    <!-- 主要信息部分 -->
    <div class="main-box">
      <!-- 左边 -->
      <div class="left-box">
        <!-- 左边button部分 -->
        <div class="left-button">
          <button class="left-button-2" @click="addClick">
            {{ $t("chooseRecommender") }}
          </button>
          <button class="left-button-1" @click="collect">
            {{ $t("collection") }}
          </button>
        </div>
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <!-- 案件名 -->
          <div class="case-name">
            <div class="title">{{ $t("projectTitle") }}</div>
            <p class="title-name">{{ this.tableData.jobName }}</p>
          </div>
          <!-- 显示图片 -->
          <div class="case-img">
            <img
              :src="imgList1"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
            <img
              :src="imgList2"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
            <img
              :src="imgList3"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
          </div>
          <!-- 标签部分 -->
          <div class="label">
            <!--qaq-->
            <div class="label-box-active" v-if="this.tableData.label1 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.tableData.jplabel1_dictText }}
              </div>
              <div v-else>{{ this.tableData.label1_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.tableData.label2 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.tableData.jplabel2_dictText }}
              </div>
              <div v-else>{{ this.tableData.label2_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.tableData.label3 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.tableData.jplabel3_dictText }}
              </div>
              <div v-else>{{ this.tableData.label3_dictText }}</div>
            </div>
            <div class="label-box-active" v-if="this.tableData.label1 == 1">
              <div v-if="language == 'ja-JP'">
                {{ this.tableData.jplabel1_dictText }}
              </div>
              <div v-else>{{ this.tableData.label1_dictText }}</div>
            </div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">

            <div class="inline-left">
              <div class="inline-left-title">
                {{ $t("occupationCategory") }}
              </div>

              <div v-if="language == 'ja-JP'">
                {{ this.tableData.jpworkType_dictText }}
              </div>
              <div v-else>{{ this.tableData.workType_dictText }}</div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("workLocation") }}</div>
              <el-tooltip :content="tableData.workSpace">
                <div class="inline-left-title-main">
                  {{ this.tableData.workSpace }}
                </div></el-tooltip
              >
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("employmentForm") }}</div>
             
              <el-tooltip :content="
              (this.tableData.employmentForm1 == 1?language == 'ja-JP'?this.tableData.jpemploymentForm1_dictText: this.tableData.employmentForm1_dictText:'')
              +' '+(this.tableData.employmentForm2 == 1?language == 'ja-JP'?this.tableData.jpemploymentForm2_dictText: this.tableData.employmentForm2_dictText:'')
              +' '+(this.tableData.employmentForm3 == 1?language == 'ja-JP'?this.tableData.jpemploymentForm3_dictText: this.tableData.employmentForm3_dictText:'')
              +' '+(this.tableData.employmentForm4 == 1?language == 'ja-JP'?this.tableData.jpemploymentForm4_dictText: this.tableData.employmentForm4_dictText:'')       
              ">
              
                 
              <div class="inline-left-title-main">
                <!--qaq-->
                <span v-if="this.tableData.employmentForm1 == 1">
                  <span v-if="language == 'ja-JP'">{{
                    this.tableData.jpemploymentForm1_dictText
                  }}</span>
                  <span v-else>{{
                    this.tableData.employmentForm1_dictText
                  }}</span>
                </span>
                <span v-if="this.tableData.employmentForm2 == 1">
                  <span v-if="language == 'ja-JP'">{{
                    this.tableData.jpemploymentForm2_dictText
                  }}</span>
                  <span v-else>{{
                    this.tableData.employmentForm2_dictText
                  }}</span>
                </span>
                <span v-if="this.tableData.employmentForm3 == 1">
                  <span v-if="language == 'ja-JP'">{{
                    this.tableData.jpemploymentForm3_dictText
                  }}</span>
                  <span v-else>{{
                    this.tableData.employmentForm3_dictText
                  }}</span>
                </span>
                <span v-if="this.tableData.employmentForm4 == 1">
                  <span v-if="language == 'ja-JP'">{{
                    this.tableData.jpemploymentForm4_dictText
                  }}</span>
                  <span v-else>{{
                    this.tableData.employmentForm4_dictText
                  }}</span>
                </span>
              </div>
              </el-tooltip
              >
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("dutyTime") }}</div>
              <div class="inline-left-title-main">
                {{ this.tableData.workTime }}
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("salary") }}</div>
              <div class="inline-left-title-main">
                <span v-if="language == 'ja-JP'">{{
                  this.tableData.jphourSalary_dictText
                }}</span>
                <span v-else>{{ this.tableData.hourSalary_dictText }}</span>


                <span> {{ this.tableData.startSalary }}~{{ this.tableData.endSalary }}</span>
              </div>


            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("numberOfHires") }}</div>
              <div class="inline-left-title-main">
                {{ this.tableData.recruitNumber }}
              </div>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("recruiter") }}</div>
              <div class="inline-left-title-main">
                {{ this.tableData.userName }}
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">
                {{ $t("targetRecruitmentTime") }}
              </div>
              <div
                class="inline-left-title-main"
                v-if="this.tableData.principalTime"
              >
                {{ this.tableData.principalTime.split(" ")[0] }}
              </div>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("workContent") }}</div>
            <el-tooltip :content="tableData.workContent">
              <div class="long-box-main">
                {{ this.tableData.workContent }}
              </div></el-tooltip
            >
          </div>
          <!-- 第六行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("welfare") }}</div>
            <el-tooltip :content="tableData.welfareTreatment">
              <div class="long-box-main">
                {{ this.tableData.welfareTreatment }}
              </div></el-tooltip
            >
          </div>
          <!-- 第七行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("employmentConditions") }}</div>
            <el-tooltip :content="tableData.welfareTreatment">
              <div class="long-box-main">
                {{ this.tableData.employmentConditions }}
              </div></el-tooltip
            >
          </div>
          <!-- 第八行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("other") }}</div>
            <el-tooltip :content="tableData.other">
              <div class="long-box-main">
                {{ this.tableData.other }}
              </div></el-tooltip
            >
          </div>
        </div>
      </div>
      <!-- 右边聊天部分 -->
      <div class="right-box">
        <Socket></Socket>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import {
  medicalResumeDetailInfo,
  addEducationCollect,
  getUrlFromOSS,
  jobInfoQuery
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "educationViewJobInformation",
  components: { Socket },
  data() {
    return {
      tableData: [],
      qaq: "",
      imgList1: "",
      imgList2: "",
      imgList3: "",
      language: ""
    };
  },
  created() {
    this.language = this.$i18n.locale;
    // this.$route.params.id;
    //console.log(this.$route.params.id);
    this.start();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据4------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.start();
      }
    },
    //图片回显
    getUrlList(url, number) {
      console.log("url" + url + number);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            if (number == 0) {
              this.imgList1 = aesFecInfo.message;
              console.log("第一張：" + this.imgList1);
            } else if (number == 1) {
              this.imgList2 = aesFecInfo.message;
              console.log("第二張：" + this.imgList2);
            } else if (number == 2) {
              this.imgList3 = aesFecInfo.message;
              console.log("第三張：" + this.imgList3);
            }
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //添加收藏
    collect() {
      console.log(this.$route.query.id);
      var educationCollectAddDTO = {
        systemEventId: this.$route.query.id,
        systemTypeId: 4
      };
      addEducationCollect(educationCollectAddDTO)
        .then(res => {
          if (res.data.code === "A0000") {
            console.log(res);
            this.$message({
              message: "恭喜你，收藏成功",
              type: "success"
            });
            this.$router.push("/educationalInstitutionCaseCollectionList");
          } else if (res.data.code === "A0506") {
            this.$message.error(this.$t("已收藏请勿重复操作"));
          } else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询方法
    start() {
      var that = this;
      let params = {
        jobId: this.$route.query.id
      };
      jobInfoQuery(params)
        .then(res => {
          if (res.data.code === "A0000") {
            console.log(res, "464614984984");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.tableData = aesFecInfo.data[0];
            that.getUrlList(that.tableData.jobPhoto1, 0);
            that.getUrlList(that.tableData.jobPhoto2, 1);
            that.getUrlList(that.tableData.jobPhoto3, 2);
            console.log(that.tableData);
            console.log(aesFecInfo);
          } else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addClick() {
      this.$router.push({
        name: "educationalInstitutionAddRecruiter",
        params: {
          jobId: this.tableData.jobId,
          jobName: this.tableData.jobName,
          medicalName: this.tableData.medicalName,
          userName: this.tableData.userName
        }
      });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.top-title {
  height: 40px;
  width: 92.5%;
  padding: 0 20px;
  margin-left: 2.5%;
}
.top-name {
  padding: 0 50px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: left;
}
.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}
.main-box {
  width: 90%;
  min-width: 974.69px;
  margin: 20px auto;
  /* margin-top: 20px; */
  /* margin-left: 250px; */
  flex: 1;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-box {
  width: 50%;
  height: 650px;
  float: left;
  overflow: hidden;
  padding-bottom: 20px;
}
.main-left-box {
  width: 100%;
  padding-right: 18px;
  height: 650px;
  overflow-y: scroll;
}
.left-button {
  width: 100%;
  height: 41px;
}
.left-button-1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  float: right;
  margin-left: 5px;
}
.left-button-2 {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  float: right;
  margin-left: 5px;
}
.case-name {
  height: 55px;
  width: 100%;
}
.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}
.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}
.case-img img {
  width: 150px;
  height: 114px;
}
.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}
.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}
/*qaq*/
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.inline-left {
  width: 29%;
  height: 80px;
  margin-right: 45px;
  float: left;
}
.inline-right {
  width: 240px;
  height: 80px;
  margin-right: 45px;
  float: left;
}
.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.inline-left-title-main {
  height: 50px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inline-box {
  height: 80px;
  width: 100%;
  margin-top: 10px;
}
.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 150px;
}
.long-box-title {
  height: 30px;
  line-height: 30px;
  width: 90%;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}
.long-box-main {
  width: 90%;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.right-box {
  width: 38%;
  height: 700px;
  float: left;
  margin-left: 80px;
}
</style>
<style>
.right-box .search {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationViewJobInformation/index.vue